import { dict } from 'src/types'

/**
 * BE errors --> FE errors
 */
export const DESCRIPTIONS_FE: dict<string> = {
  '500002000':
    "Non e' stato possibile recuperare le informazioni dalla banca dati Ania. Vai al $$$.",
  '500002001':
    'Gentile cliente, il codice fiscale e la data di nascita che hai inserito non combaciano.\nTi chiediamo di reinserire i dati richiesti o di procedere con il $$$.',
  '500002002':
    "Il servizio e' attivo per le auto intestate a persone fisiche. Per una quotazione personalizzata puoi rivolgerti ai nostri Agenti.",
  '500002003':
    'Attestato di rischio non presente in banca dati ANIA per il proprietario attuale. Vai al $$$.',
  '500002004':
    "Non e' stato possibile recuperare le informazioni dalla banca dati Ania. La data di nascita inserita non corrisponde alla targa. Vai al $$$",
  '500002005':
    'Gentile socio assicurato, la targa *** risulta già assicurata con una compagnia del gruppo ITAS.\nPer procedere vai al $$$ o rivolgiti in agenzia per avere una consulenza su misura.\nTi ricordiamo che accedendo all’area riservata troverai tutte le informazioni sulle tue polizze.',
  '500002006': "La targa inserita non e' corretta!",
  '500002007': 'Per procedere su questa tipologia di veicolo vai al $$$.',
  '500002008': "Errore generico, contattare l'assistenza!",
}
